'use strict';

const expandAndReduceContainer = (opts) => {

   	const expandButton = document.querySelector('.expand-button');
	const reduceButton = document.querySelector('.reduce-button');
    const selector = opts.selector || '';

	if (expandButton && reduceButton) {	
		 expandButton.addEventListener('click', function handleClick(){
			selector.classList.add('expanded');
			selector.style.setProperty("--height", `${selector.scrollHeight}px`);
			expandButton.classList.add('invisible');
			reduceButton.classList.remove('invisible');
		});

		reduceButton.addEventListener('click', () => {
			if (selector) {			
				selector.classList.remove('expanded');
				reduceButton.classList.add('invisible');
				expandButton.classList.remove('invisible');
			}
		});
	}   
};

const activateSeeMoreButton = (selector) => {
    const textContainer = selector;

    if (!textContainer) {
        return;
    }

    expandAndReduceContainer({
        selector: textContainer,
    });
};

export default activateSeeMoreButton;